var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "customProjectTasks" }, [
    _c("div", { staticClass: "flex w-auto w-full flex-col containerTop" }, [
      _c(
        "div",
        { staticClass: "flex justify-between items-center w-full mb-2" },
        [
          _c("div", { staticClass: "mb-2" }, [
            _c("h3", { staticClass: "text-sm font-semibold text-blue-600" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.activity.project?.client_name || "Unknown Client"
                  ) +
                  " "
              ),
            ]),
          ]),
          !_vm.isCompleted
            ? _c(
                "div",
                { staticClass: "mb-2 flex flex-row items-center" },
                [
                  _c("EditTaskAction", {
                    attrs: {
                      isIcon: true,
                      projectActivity: _vm.activity,
                      companyId: _vm.activity.project?.company.id,
                      currentUserId: _vm.currentUserId,
                      currentUserRole: _vm.currentUserRole,
                    },
                  }),
                  _c("DeleteTaskAction", {
                    attrs: {
                      currentUserRole: _vm.currentUserRole,
                      companyId: _vm.activity.project?.company.id,
                      projectActivity: _vm.activity,
                    },
                    on: { visitDeleted: _vm.visitUpdated },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isCompleted
            ? _c(
                "div",
                {
                  staticClass: "flex flex-row justify-between items-center h-8",
                },
                [
                  _c("p", {
                    staticClass:
                      "text-sm leading-normal font-400 text-storm-gray",
                  }),
                  _c("CardInfoChip", {
                    staticClass: "mr-4",
                    attrs: { message: "Completed" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "flex flex-col gap-2 adjustItems" }, [
        _vm.activity.virtual && _vm.activity.virtual_meeting_link
          ? _c(
              "a",
              {
                staticClass:
                  "text-blue text-sm font-400 hover:underline inline-flex items-center gap-1",
                attrs: {
                  href: _vm.activity.virtual_meeting_link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "2",
                        y: "7",
                        width: "20",
                        height: "15",
                        rx: "2",
                        ry: "2",
                      },
                    }),
                    _c("polyline", { attrs: { points: "22,7 12,13 2,7" } }),
                  ]
                ),
                _vm._v(" Join Virtual Meeting "),
              ]
            )
          : _vm.location
          ? _c("p", { staticClass: "text-blue text-sm font-400" }, [
              _vm._v(" " + _vm._s(_vm.location) + " "),
            ])
          : _c("p", { staticClass: "text-blue text-sm font-400" }, [
              _vm._v("n/a"),
            ]),
        _vm.activity.virtual && _vm.activity.fallback_num
          ? _c(
              "div",
              { staticClass: "flex items-center gap-1 text-gray-600" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "12",
                      height: "12",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                      },
                    }),
                  ]
                ),
                _c("span", { staticClass: "text-xs" }, [
                  _vm._v(_vm._s(_vm.activity.fallback_num)),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "flex flex-col gap-2 mb-3 mt-3" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("CalendarIcon", { staticClass: "h-5 w-5" }),
            _c("p", { staticClass: "projectInfo ml-2" }, [
              _vm._v(" " + _vm._s(_vm.createdAt) + " "),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("LocationIcon", { staticClass: "h-5 w-5" }),
            _c("p", { staticClass: "projectInfo ml-2" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.startTime) +
                  " - " +
                  _vm._s(_vm.endTime) +
                  " " +
                  _vm._s(_vm.totalHours && _vm.totalHours) +
                  " "
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex mb-3" },
          [
            _c("StarIcon", { staticClass: "h-5 w-5" }),
            _c("p", { staticClass: "projectInfo ml-2" }, [
              _vm._v("Type of activity: " + _vm._s(_vm.typeOfVisit)),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }